import { uiText } from '../i18n/uiText';

// Only the controlled workspace API captions; never transform arbitrary
// comments, company names, answers or document content.
export function auditSignalText(signal, locale) {
  if (typeof signal !== 'string') return signal;
  let match = signal.match(/^(\d+) просроченных замеч\.$/);
  if (match) return uiText('{count} просроченных замеч.', { count: match[1] }, locale);
  match = signal.match(/^(\d+) открытых замеч\.$/);
  if (match) return uiText('{count} открытых замеч.', { count: match[1] }, locale);
  return ['срок аудита прошёл', 'нет аудитора', 'нет проверяемого'].includes(signal) ? uiText(signal, {}, locale) : signal;
}
